<template>
  <v-flex ml-4 cols="12" sm="4" md="8">
    <div v-if="!loading">
      <carousel
        class="ma-0 pa-0"
        paginationActiveColor="#50B380"
        paginationColor="#A5B0C0"
        :paginationSize="6"
        :paginationPadding="5"
        :per-page="1"
      >
        <slide v-for="(item, index) in data" :key="item.id">
          <div :style="{ background: colors[index] }" class="bar"></div>

          <p class="mb-2 a-title">{{ item.name }}</p>

          <div
            v-for="(i, index) in item.data"
            :key="`${i.name}-${index}`"
            class="d-flex flex-column"
          >
            <span class="a-text grayLight--text gray--text WeightTextGray">
              {{ i.name }}
            </span>
            <span class="text-center pb-1">
              <span class="a-historical">{{ `${i.percentage} ` }}</span>
              <span class="a-eu">%</span>
            </span>

            <div class="a-text-sm text-center pb-1">
              <span class="a-historical">
                {{ i.measurement }}
              </span>
              <span>/ </span>
              <span class="a-text-sm a-goal">{{ `${i.goal} ` }}</span>
              <span class="a-eu">{{ eu }}</span>
            </div>
            <v-divider class="ma-0 pa-0" v-if="index !== 2"></v-divider>
          </div>
        </slide>
      </carousel>
    </div>
    <SkeletonCarousel v-else />
  </v-flex>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import SkeletonCarousel from "./SkeletonCarousel.vue";

export default {
  name: "GraphData",
  components: {
    Carousel,
    Slide,
    SkeletonCarousel,
  },
  props: {
    data: Array,
    eu: String,
    loading: {
      default: true,
      type: Boolean,
    },
    colors: Array,
  },
  computed: {
    _datasets() {
      let datasets = [...this.datasets];
      if (datasets.length > 0) {
        return datasets.filter((dataset) => dataset.data && dataset.data.length);
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.bar {
  width: 20px;
  height: 4px;
  border-radius: 4px;
}

.VueCarousel-dot,
.VueCarousel-dot:focus {
  outline: none !important;
}
.WeightTextGray {
  font-weight: 200;
}
</style>
